module.exports = __webpack_public_path__ + "static/media/materialdesignicons-webfont.7ec5dab7.woff2";